<template>
  <div class="app-container pull-auto">
    <basic-container>
      <avue-crud ref="crud"
        v-if="permissions.sensitive_words_list" 
        :page="page"
        :data="tableData"
        :table-loading="tableLoading"
        :option="tableOption"
        @current-change="currentChange"
        @refresh-change="refreshChange"
        @row-update="handleUpdate"
        @row-save="handleSave"
        @row-del="rowDel"
        @size-change="sizeChange"
        @search-change="searchChange"
        @search-reset="searchReset">
        <template slot="menuLeft">
          <el-button type="primary"
            @click="handleAdd"
            size="small"
            v-if="permissions.sensitive_words_add">新 增</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="text"
            v-if="permissions.sensitive_words_edit"
            icon="el-icon-check"
            size="small"
            @click="handleEdit(scope.row,scope.index)">编辑</el-button>
          <el-button type="text"
            v-if="permissions.sensitive_words_delete"
            icon="el-icon-delete"
            size="small"
            @click="handleDel(scope.row,scope.index)">删除</el-button>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
  import { fetchList, createWords, updateWords, deleteWords, getWords} from '@/api/setting/words'
  import { tableOption } from '@/const/crud/setting/words'
  import { mapGetters } from 'vuex'
  export default {
    data() {
      return {
        tableLoading: false,
        tableOption: tableOption,
        tableData: [],
        page: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 20 // 每页显示多少条
        },
        listQuery: {
          wordType: 1,
          current: 1,
          size: 20,
        },
      }
    },
    created() {
      this.getList()
    },
    mounted: function() { },
    computed: {
      ...mapGetters(['permissions'])
    },
  methods: {
    getList() {
      this.tableLoading = true
      fetchList(this.listQuery).then(response => {  
        this.tableData = response.data.data.records
        this.page.total = response.data.data.total
        this.tableLoading = false
      })
    },
    searchReset () {
      this.listQuery.word = ''
      this.searchChange(this.listQuery.word)
    },
    searchChange (params) {
      this.page.currentPage = 1
      this.listQuery.current = 1
      this.listQuery.wordType = 1
      this.listQuery.word = params.word
      this.getList()
    },
    currentChange(val) {
      this.page.currentPage = val
      this.listQuery.current = val
      this.getList()
    },
    sizeChange(val) {
      this.page.pageSize = val
      this.listQuery.size = val
      this.getList()
    },
    handleAdd() {
      this.$refs.crud.rowAdd()
    },
    handleSave(data, done) {
      const newWord = {
        word: data.word,
        wordType: 1,
      };
      createWords(newWord).then((res) => {
        if (res.data.code === 0) {
          this.$message({
            showClose: true,
            message: '添加成功',
            type: 'success'
          })
          this.listQuery.word = ''
          this.getList()
          done();
        } else {
          this.$message({
            showClose: true,
            message: '添加失败',
            type: 'warning',
          })
        }
      }).catch((error) => {
        done()
      });
    },
    handleEdit (row, index) {
      this.$refs.crud.rowEdit(row, index);
    },
    handleUpdate(row, index, done){
      const word = {
        id: row.id,
        word: row.word,
        wordType: 1,
      };
      updateWords(word).then(data => {
        if (data.data.code === 0) {
          this.$message({
            showClose: true,
            message: '修改成功',
            type: 'success'
          })
          this.listQuery.word = ''
          this.getList()
          done()
        } else {
          this.$message({
            showClose: true,
            message: '修改失败',
            type: 'warning'
          })
        }
      }).catch((error) => {
        done()
      });
    },
    handleDel (row, index) {
      this.$refs.crud.rowDel(row, index)
    },
    rowDel(row, index, done) {
      this.$confirm('是否确认删除敏感词为"' + row.word + '"的记录', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(function () {
        return deleteWords(row.id);
      }).then(data => {
        if (data.data.code === 0) {
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success'
          })
          this.getList()
          done()
        } else {
          this.$message({
            showClose: true,
            message: '删除失败',
            type: 'warning'
          })
        }
      })
    },
    refreshChange() {
      this.getList()
    },
  }
}
</script>
<style lang="scss" scoped>
</style>
